import React, { useEffect, useState, FC, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.css';
import './style.css';
import { MultiSelect } from "primereact/multiselect";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Dropdown } from 'primereact/dropdown';
import Highcharts, { color, TooltipFormatterContextObject } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import CustomDateRange from '../customDateRange/CustomDateRange';
import moment from 'moment';
import csvDownload from "json-to-csv-export";
import { getAllDetails, getPropertyCharts, getRollingChartsDetailsSymbolWise, getSymbolsDetails, getTableExport } from '../../api/otherEndPoints/historicalPerformance';
import jsPDF from 'jspdf';
import ImageExport from '../base64_images/feedsense_image';
import PortFolioEvaluation from '../portfolioEvaluation/portfolioEvaluation';
import { useParams } from 'react-router-dom';
import { equityPositivePeriodAndMarketBeatMapping, equityPositivePeriodAndMarketBeatMappingTableHeader, generaliseExportCSV, performanceMetricMapping, performanceMetricMappingTableHeader, portFolioCriticalMetricMapping, portFolioCriticalMetricMappingTableHeader } from '../../services/util/util';
import GeneralisePreviewTable from '../adviceStatus/GeneralisePreviewTable';
import { log } from 'console';
require('jspdf-autotable');


interface UserData {
  duration: string[];
  ocValues: number[];
  returnAfterCostValues: number[];
  maxDrawdown: number[];
  successPercentageValues: number[];
}

interface Rolling {
  s_symbol: string,
  Total_Trades: number,
  Win_Trades: number,
  Loss_Trades: number,
  Success: number,
  Gross_Profit: number,
  Gross_Loss: number,
  Net_Profit: number,
  Return: number,
  Return_with_cost: number,
  O_to_C_Return:number,
  Max_Drawdown_Actual:number,
  Max_Loss: number,
  Max_Profit: number,
  RRR: number,
  O_to_C_Point: number,
  Market_Beat: number,
  Profit_Loss_Ratio: number,
  Avg_profit_trade: number,
  Avg_loss_trade: number,
  Holding_Peroid:number
}

interface displaySymbols{
  name: string,
  value: string
}

interface props{
  codes: string[]
}


const App: React.FC<props> = ({codes}) => {
  const { type }:any = useParams();
  const [users, setUsers] = useState<any>([]);
  const [selectedSymbol, setselectedSymbol] = useState<string[]>([]);
  const [selectedPortfolioSymbol, setSelectedPortfolioSymbol] = useState<string[]>([]);
  const [symbolsOptions, setSymbolsOptions] = useState<any>();
  const [userData, setUserData] = useState<UserData>({ duration: [], ocValues: [], returnAfterCostValues: [], maxDrawdown: [], successPercentageValues: [] });
  const [drpValue, setDrpValue] = useState<string>(type === 'equityMultiday' ? 'N50_all' : type === 'equityN50NXT' ? 'N50_next_all' : type === 'equityN50BANK' ? "N50_bank_all": codes[0]);
  const [startDate, setStartDate] = useState<any>('2019-04-09');
  const [endDate, setEndDate] = useState<any>(moment().format("YYYY-MM-DD"));
  const [strategyBg, setStrategyBg] = useState<any>(['#f9f9fa','inset 1px rgb(42, 153, 187)']);
  const [portfolioBg, setPortfolioBg] = useState<any>(['rgb(239 239 239 / 84%)', 'none']);
  const [rolling, getRolling] = useState([]);
  const [isToggled,setToggled] = useState(true)
  const [selectedRisk, getSelectedRisk] = useState<string>('Avg loss/trade');
  const [selectedReward, getSelectedReward] = useState<string>('Avg profit/trade');
  const [selectedMisc, getSelectedMisc] = useState<string>('Total Trades');
  const [displayRisk, setDisplayRisk] = useState<{ duration: string[]; property: number[] }>({ duration: [], property: [] });
  const [displayReward, setDisplayReward] = useState<{ duration: string[]; property: number[] }>({ duration: [], property: [] });
  const [displayMisc, setDisplayMisc] = useState<{ duration: string[]; property: number[] }>({ duration: [], property: [] });
  const [exportData, setExportData] = useState<any>();
  const [portfolio, setPortfolio] = useState<boolean>(false);
  const [strategy, setStrategy] = useState<boolean>(true);

  
  
  const columnRisk = [
    {name: "Avg Loss/Trade",value:"Avg loss/trade"},
    {name: "Gross Loss",value:"Gross Loss"},
    {name: "Loss Trades",value:"Loss Trades" },
    {name: "Max Drawdown",value:"Max Drawdown Actual"}, 
    {name: "Profit/Loss Ratio",value:"Profit/Loss Ratio"},     
  ]

  const columnReward = [    
    {name: "Avg Profit/Trade", value: "Avg profit/trade"},
    {name: "Gross Profit",value:"Gross Profit"},
    {name: "Max Profit",value:"Max Profit"},  
    {name: "Net Profit",value:"Net Profit"},
    {name: "Return (%)",value:"Return %"},
    {name: "Success (%)",value:"Success %"},
    {name: "Win Trades", value:"Win Trades"}, 
  ]

  const columnMisc = [
    {name: "Total Trades", value:"Total Trades"}, 
    {name: "Market Beat" ,value:"Market Beat (in Return %)"}, 
  ]
  
  const exportPdfColumns = [
    {name: "Serial No.", value: "serial"},
    {name: "Asset name", value: "asset"},
    {name: "Avg Trades per Year",value:"trades"},
    {name: "Avg Trading Days", value:"trade_days"}, 
    {name: "Success Ratio (%)",value:"success_ratio"},  
    {name: "Maximum Drawdown (%)",value:"max_drawdown"},
    {name: "Avg P/L Ratio",value:"pl"},
    {name: "Avg Return after cost ",value:"return_cost"},
    {name: "Avg Market Beat (%)", value:"marketBeat"}, 
    {name: "Positive Months(%) ", value:"monthly"}, 
    {name: "Positive Quarter (%) ", value:"quarterly"}, 
  ]
  const exportCols = exportPdfColumns.map((exportPdfColumn) => ({ title: exportPdfColumn.name, dataKey: exportPdfColumn.value }));


  //-------------------CSV PREVIEW-------------//
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedPreviewTableData, setSelectedPreviewTableData] = useState<any[]>([]);
  const [selectedPreviewTableColumns, setSelectedPreviewTableColumns] = useState<any[]>([]);
  const [selectedPreviewTableColumnMapping, setSelectedPreviewTableColumnMapping] = useState<any>({});
  const [selectedFileName, setSelectedFileName] = useState<string>("");


  const memorizedExportCSV = useCallback(generaliseExportCSV,[isModalOpen,selectedPreviewTableData]);
  // const onDownload = useCallback(() => memorizedExportCSV(selectedPreviewTableData,selectedPreviewTableColumnMapping,"MonthlyReturns.csv"), [memorizedExportCSV,selectedPreviewTableData]);
  
  function addWaterMark(doc: any) {
    var totalPages = doc.internal.getNumberOfPages();  
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(48)
      doc.setFont('Helvetica', 'bold')
      doc.setTextColor(230,230,230);
      doc.saveGraphicsState();
      doc.setGState(new doc.GState({opacity: 0.8}));
      doc.text('FeedSense AI', 160,160, null, 45, 'center');
      doc.restoreGraphicsState();
    }  
    return doc;
  }

  const addFooters = (doc: any) => {
    const pageCount = doc.internal.getNumberOfPages()
    doc.setFont('helvetica', 'italic')
    doc.setTextColor(0,0,0);
    doc.setFontSize(10)
    for (var i = 2; i <= pageCount; i++) {
      doc.setPage(i)
      if(i==1){
        doc.text(`Generated for ${moment(startDate).format('DD MMM YYYY')} - ${moment(endDate).format('DD MMM YYYY')}`,10,200)
      }
      doc.text('Page ' + String(i) + ' of ' + String(pageCount),260,200)
      if(i == pageCount){
        doc.setFont('Helvetica', 'italic')
        doc.text('Disclaimer: We are using statistical and artificial models etc. which are never error-free. Please apply your own discretions while using this information.',10,200)
      }
    }
  }
  const exportPdf = () => {
    var doc = new jsPDF('l');
     var image = ImageExport()
       
    const imageWidth = 50;
    const imageHeight = 15;
    const pageWidth = doc.internal.pageSize.getWidth();
    const imageX = (pageWidth - imageWidth) / 2;
        // doc.addImage(image, 'PNG',125, 10, 50, 15);
        doc.setFont('Lato-Regular', 'bold')
        doc.setFontSize(13)
        doc.text('Annualized Performance Summary of Cash Models', 145, 35, { align: 'center'});
        (doc as any).autoTable(exportCols, exportData, {
          styles: {
            halign: 'left'
        },
        startY: 40,
        margin: { top: 30 }, // <-- This prevents overlapping on all pages
        headStyles :{lineWidth: 0.5,fillColor: [224, 224, 224],textColor: [0,0,0]},
        didDrawPage: (data: any) => {
          // Draw image in header (every page)
          doc.addImage(image, 'PNG', imageX, 8, imageWidth, imageHeight);
    
          // Horizontal line
          doc.setLineWidth(0.1);
          doc.line(10, 25, pageWidth - 10, 25);
        },
        theme: 'grid',
      }
     );
    doc = addWaterMark(doc)
    // addHeaders(doc, image);
    addFooters(doc)
    doc.save('Feedsense AI brochure.pdf');
  };

function findKeyByValue(obj: any, value1: any): any | undefined {
  let display = obj.find((object:any) => object.value === value1);
  return display["name"]
}

const handleToggle = () =>{
  setToggled(!isToggled)
}

const tradesExports = (data: any, value:number) => {
  if(value === 1){
      const tradeDataToConvert = {
        data: users,
        filename: `Rolling Details`,
        delimiter: ",",
        headers: [
          "s_symbol",
          "Total_Trades",
          "Win_Trades",
          "Loss_Trades",
          "Success",
          "Gross_Profit",
          "Gross_Loss",
          "Net_Profit",
          "Return",
          "Return_with_cost",
          "O_to_C_Return",
          "Max_Drawdown_Actual",
          "Max_Loss",
          "Max_Profit",
          "RRR",
          "O_to_C_Point",
          "Market_Beat",
          "Profi_Loss_Ratio",
          "Avg_profit_trade",
          "Avg_loss_trade"
        ],
    }
    csvDownload(tradeDataToConvert);
  }
  else{
      const tradeDataToConvert = {
        data: rolling,
        filename: `Rolling Summary (Monthly/Quarterly/Yearly)`,
        delimiter: ",",
        headers: [
          "s_symbol",
          "rolling_21",
          "rolling_65",
          "rolling_252",
          "marketBeat",
          "yearlyAvgReturn",
          "score"
        ],
    } 
    csvDownload(tradeDataToConvert);
  }
}

const optionsReturn = {
  title: {
    text: `${'N50_all' === drpValue ? 'Models Return After Cost (Equal Weights) VS Nifty 50'  : 'N50_next_all' === drpValue ? 'Models Return After Cost (Equal Weights) VS Nifty 50 Next' : 'N50_bank_all' === drpValue ? 'Models Return After Cost (Equal Weights) VS Nifty 50 Next' : drpValue +'\u00A0(Market VS Model Return After Cost)'} `,
  },
  xAxis: {
    categories: userData?.duration,
    labels: {
      rotation: -90,
      steps:1000,
    },
    crosshair: {
      color: '#FF0000', // Red cursor line color
      width: 1,
      dashStyle: 'dash' // Style of the crosshair line
    }
  },
  series: [
    {
      name: 'Market Return',
      data: userData?.ocValues,
      color: '#568ccd'
    },
    {
      name: `Model Return`,
      data: userData?.returnAfterCostValues,
      color: '#4fc967'
    }
  ],
  tooltip: {
    shared: true, // Shared tooltip for both series
    useHTML: true,
    formatter: function (this: TooltipFormatterContextObject) {
      const points:any = this?.points || [];
      let tooltip:any = `<b>${this?.x}</b><br>`;
      if (points.length === 2) {
        tooltip +=  `<span style="color:${points[0].color}">\u25CF</span> ${points[0].series.name}: <b>${(points[0].y).toFixed(2)}</b><br>
                     <span style="color:${points[1].color}">\u25CF</span> ${points[1].series.name}: <b>${(points[1].y).toFixed(2)}</b><br>`;
      }
      return tooltip;
    }
  },
  chart: {
    height: 600,
    type : 'area',
    borderWidth: -1,
    spacingTop: 25
  },
  credits: { enabled: false },
  accessibility: {
    enabled: false
  },
  plotOptions: {
    series: {
        fillOpacity: 0.1
    },
  },
  legend: {
    align: 'right',
    verticalAlign: 'top',
    x: 0,
    y: 0
  },
  yAxis:{
    gridLineWidth : 0,
    crosshair: {
      color: '#FF0000', // Red cursor line color
      width: 1,
      dashStyle: 'dash' // Style of the crosshair line
    }
  },
};

const optionRisk = {
title: {
    text: ``
  },
  xAxis: {
    categories: displayRisk?.duration,
    labels: {
      rotation: -90,
      steps:1000,
    }
  },
  tooltip: {
    valueDecimals: 2,
  },
  series: [
    {
      name: `${findKeyByValue(columnRisk,selectedRisk)}`,
      data: displayRisk?.property
    },
  ],
  chart: {
    height: 600,
    type: 'area',
    borderWidth: -1,
    spacingTop: 25
  },
  credits: { enabled: false },
  accessibility: {
    enabled: false
  },
  plotOptions: {
    series: {
        fillOpacity: 0.1,
        color: '#da7958'
    }
},
legend: {
  align: 'right',
  verticalAlign: 'top',
  x: 0,
  y: 0,
},
yAxis:{
gridLineWidth : 0
}
};

const optionReward = {
  title: {
    text: ``
  },
  xAxis: {
    categories: displayReward?.duration,
    labels: {
      rotation: -90,
      steps:1000,
    }
  },
  series: [
    {
      name: `${findKeyByValue(columnReward,selectedReward)}`,
      data: displayReward?.property
    },
  ],
  tooltip: {
    valueDecimals: 2,
  },
  chart: {
    height: 600,
    type: 'area',
    borderWidth: -1,
    spacingTop: 25
  },
  credits: { enabled: false },
  accessibility: {
    enabled: false
  },
  plotOptions: {
    series: {
        fillOpacity: 0.1,
        color: '#c7c47d'
    }
},
legend: {
  align: 'right',
  verticalAlign: 'top',
  x: 0,
  y: 0,
},
yAxis:{
gridLineWidth : 0
}
};

const optionMisc = {
  title: {
    text: ``
  },
  xAxis: {
    categories: displayMisc?.duration,
    labels: {
      rotation: -90,
      steps:1000,
    }
  },
  series: [
    {
      name: `${findKeyByValue(columnMisc,selectedMisc)}`,
      data: displayMisc?.property
    },
  ],
  chart: {
    height: 600,
    type: 'area',
    borderWidth: -1,
    spacingTop: 25
  },
  credits: { enabled: false },
  accessibility: {
    enabled: false
  },
  plotOptions: {
    series: {
        fillOpacity: 0.1,
        color: '#72418c',
    }
},
legend: {
  align: 'right',
  verticalAlign: 'top',
  x: 0,
  y: 0,
},
yAxis:{
gridLineWidth : 0
}
};


useEffect(() => {
  try{
    const fetchingAllDetails = async () => {
      type === 'equityMultiday' ? (codes = codes.filter(item => item!= 'N50_next_all' && item.split('_')[1] != 'EB')) : type === 'equityN50BANK' ?(codes = codes.filter(item => item!= 'N50_next_all')):codes.push('N50_next_all')
      let response:any = await getAllDetails(codes)
      setUsers(response.data[0]);
      let symbolOptions:any = []
      if (type === 'equityMultiday'){
        symbolOptions= response?.data[0]?.map((item : Rolling) => ({
         
            name: (item?.s_symbol === 'N50_all') ? 'ALL' : item?.s_symbol,
            value: item?.s_symbol,}))
      }
      // if (type === 'equityN50BANK'){
      //   symbolOptions= response?.data[0]?.map((item : Rolling) => ({
           
      //       name: (item?.s_symbol === 'N50_bank_all') ? 'ALL' : item?.s_symbol,
      //       value: item?.s_symbol,}))
      // }
      if (type === 'equityN50BANK'){
        symbolOptions= response?.data[0]?.map((item : Rolling) => ({
            name: (item?.s_symbol === 'N50_bank_all') ? 'ALL' : item?.s_symbol.split('_')[0],
            value: item?.s_symbol.split('_')[0]}))
         
      }

        symbolOptions?.sort((a:any, b:any) => {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        //@ts-ignore
        symbolOptions?.forEach(function(item,i){
          if(item.name === "ALL"){
            symbolOptions.splice(i, 1);
            symbolOptions.unshift(item);
          }
          else{
            setDrpValue(symbolOptions[0]?.value)
          }
        });        
       
      const allSymbols = response?.data[0]?.map((item : Rolling) => (
        item.s_symbol))
      setselectedSymbol(allSymbols)
      setSymbolsOptions(symbolOptions);
      getRolling(response?.data[1])    
    }
    fetchingAllDetails()
  }
  catch (error){
    console.error("Error in initial rendering:", error);
  }  
},[type]);

  useEffect(() => {
    const fetchChart = async () => {
          // let response:any = await getRollingChartsDetailsSymbolWise(drpValue, startDate, endDate)
          let response:any = await getRollingChartsDetailsSymbolWise(drpValue, startDate, endDate,type)
          const { duration, ocValues, returnAfterCostValues, maxDrawdown, successPercentageValues }:any = response?.data;
          setUserData({ duration, ocValues, returnAfterCostValues, maxDrawdown, successPercentageValues });
    }
    if(drpValue || (startDate && endDate)) {
      fetchChart();
    }
  }, [drpValue, startDate,endDate]);

  // useEffect(() => {
  //   const fetchFilteredUsers = async () => {
  //     let calculation_type = isToggled ? 'product' : 'sum';
  //       try{
  //           let response:any = await getSymbolsDetails(selectedSymbol,startDate, endDate, calculation_type)
  //           setUsers(response[0]);
  //           getRolling(response[1]);
  //           let response1: any = await getTableExport(selectedSymbol,startDate, endDate, calculation_type)
  //           setExportData(response1)
  //       } 
  //       catch (error){
  //         console.error("Error fetching datatable:", error);
  //       }
  //     }
  //   if(selectedSymbol.length > 0 || startDate || endDate){
  //     fetchFilteredUsers();
  //   }
  // }, [selectedSymbol, startDate,endDate, isToggled]);

  useEffect(() => {
    const fetchFilteredUsers = async () => {
      let calculation_type = isToggled ? 'product' : 'sum';
        try{
          if (type === 'equityMultiday'){
              let response:any = await getSymbolsDetails(selectedSymbol,startDate, endDate, calculation_type,type)
              setUsers(response[0]);
              getRolling(response[1]);
              let response1: any = await getTableExport(selectedSymbol,startDate, endDate, calculation_type,type)
              setExportData(response1)
          }
          else{
              let response:any = await getSymbolsDetails(selectedSymbol,startDate, endDate, calculation_type,type)
              response[0] = response[0].map((item: any) => ({...item,s_symbol: item.s_symbol?.split('_')[0],}));
              response[1] = response[1].map((item: any) => ({...item,s_symbol: item.s_symbol?.split('_')[0],}));
              setUsers(response[0]);
              getRolling(response[1]);
              let response1: any = await getTableExport(selectedSymbol,startDate, endDate, calculation_type,type)
              setExportData(response1)
          }
        }
        catch (error){
          console.error("Error fetching datatable:", error);
        }
      }
    if(selectedSymbol.length > 0 || startDate || endDate){
      fetchFilteredUsers();
    }
  }, [selectedSymbol, startDate,endDate, isToggled]);

  useEffect(() => {
    const fetchChart = async () => {
          // const { duration, property }:any = await getPropertyCharts(selectedRisk, startDate, endDate, drpValue);
          const { duration, property }:any = await getPropertyCharts(selectedRisk, startDate, endDate, drpValue,type);
          setDisplayRisk({ duration, property });
    }
    if (selectedRisk || (startDate && endDate) || drpValue) {
      fetchChart();
    }
  }, [selectedRisk, startDate,endDate, drpValue]);
  
  useEffect(() => {
    const fetchChart = async () => {
          const { duration, property }:any = await getPropertyCharts(selectedReward, startDate, endDate, drpValue,type);
          setDisplayReward({ duration, property });
    }
    if (selectedReward || (startDate && endDate) || drpValue) {
      fetchChart();
    }
  }, [selectedReward, startDate,endDate, drpValue]);

  useEffect(() => {
    const fetchChart = async () => {
          const { duration, property }:any = await getPropertyCharts(selectedMisc, startDate, endDate, drpValue,type);
          setDisplayMisc({ duration, property });
    }
    if (selectedMisc || (startDate && endDate) || drpValue) {
      fetchChart();
    }
  }, [selectedMisc, startDate,endDate, drpValue]);

  const valueBodyTemplate = (rowData: any) => {
    const style = {
        color: rowData.score === '*' ? 'green' : '#ACE1AF',
        fontWeight: 'bold'
    };
    return <span style={style}>{rowData.score}</span>;
};
  return (
    <div className="fullpage">
      <GeneralisePreviewTable
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          columnHeader={selectedPreviewTableColumns}
          tableData={selectedPreviewTableData}
          onDownload={()=>{memorizedExportCSV(selectedPreviewTableData, selectedPreviewTableColumnMapping, selectedFileName)}}
        />
      <div className="card">
        {type == 'equityMultiday' || type === 'equityN50BANK' ? 
        <div className='btn-group'>
            <Button className= 'tab-btn-st' onClick={ () => { setPortfolio(false); setStrategy(true); setStrategyBg(['#f9f9fa','inset 1px rgb(42, 153, 187)']); setPortfolioBg(['rgb(239 239 239 / 84%)', 'none']);}} style={{ background : strategyBg[0], border : strategyBg[1]}}><span className='btn-text'>Performance Metric</span></Button>
            <Button className= 'tab-btn-pf' onClick={ () => { setPortfolio(true); setStrategy(false); setStrategyBg(['rgb(239 239 239 / 84%)', 'none']); setPortfolioBg(['#f9f9fa', 'inset 1px rgb(42, 153, 187)']);}} style={{ background : portfolioBg[0], border: portfolioBg[1]}}><span className='btn-text'>Critical Metric</span></Button>
          </div> 
          : <></> }
        <div className='card_table_strategy'>
        <div className='dropdown1'> 
        { portfolio && (type == 'equityMultiday' || type === 'equityN50BANK' )? 
            <>
            </>
            :
            <><div className='dropdown1_headerName'>
            <MultiSelect  value={selectedSymbol} options = {symbolsOptions} onChange={(e) => setselectedSymbol(e.value)} placeholder={selectedSymbol.length === 25 ? 'All symbols': 'Select symbols'} optionLabel="name" className='multiselect' maxSelectedLabels={1} />
            &emsp;&emsp;
            <CustomDateRange backStartDate={startDate} setBackStartDate={setStartDate} backEndDate={endDate} setBackEndDate={setEndDate} />
            </div>
            </>
            }

        
          
            
          
          { portfolio && (type == 'equityMultiday' || type === 'equityN50BANK') ? <></> :
            <>
              <div className='buttonExport'>
                {<div className='toggleDiv'>
                  <span className="investmentType">Investment</span>
                                  <span className="switch">
                                      <input id="switch-rounded" checked={isToggled} type="checkbox" onChange={(e: any) => {
                                          if (e.target.checked) {
                                              handleToggle()
                                          } else {
                                              handleToggle()
                                          }
                                      }} />
                                    <label htmlFor="switch-rounded"></label>
                      </span>
                    <span className="investmentType">Reinvestment</span>
                  </div>}  
                  <Button type="button" icon="pi pi-file-pdf" rounded onClick={exportPdf} className='button1' />
                  <Button type="button" icon="pi pi-download" 
                  rounded 
                  onClick={()=>{
                    setSelectedPreviewTableData(users);
                    setSelectedPreviewTableColumns(performanceMetricMappingTableHeader);
                    setSelectedPreviewTableColumnMapping(performanceMetricMapping);
                    setSelectedFileName("Rolling Details.csv")
                    setIsModalOpen(true);
                
                }}
                  className='button1' />
                </div>
            </>
            }

        
        
        {
        portfolio && (type == 'equityMultiday' || type === 'equityN50BANK')? <PortFolioEvaluation symbols = {{selectedPortfolioSymbol}}/> 
        : 
        <>
          <div className='datatable1'>
            <DataTable value={users} scrollable resizableColumns stripedRows sortMode="multiple">
              <Column field= "s_symbol"  header= "Symbol" style={{ minWidth: '200px'}} frozen sortable></Column> 
              <Column field= "Total_Trades"  header= "Avg Total Trades" ></Column> 
              <Column field= "Win_Trades"  header= "Avg Win Trades" style={{ minWidth: '225px'}} sortable></Column> 
              <Column field= "Loss_Trades"  header= "Avg Loss Trades" ></Column> 
              <Column field= "Success"  header= "Success (%)" style={{ minWidth: '200px'}} sortable ></Column> 
              <Column field= "Gross_Profit"  header= "Gross Profit" ></Column> 
              <Column field= "Gross_Loss"  header= "Gross Loss" ></Column> 
              <Column field= "Net_Profit"  header= "Net Profit" ></Column> 
              <Column field= "Return"  header= "Return (%)" style={{ minWidth: '200px'}} sortable ></Column> 
              <Column field= "Return_with_cost"  header= "Return (%) with cost" ></Column> 
              <Column field= "O_to_C_Return"  header= "Market Return (%)" ></Column> 
              <Column field= "Max_Drawdown_Actual"  header= "Max Drawdown" ></Column> 
              <Column field= "Max_Loss"  header= "Max Loss" ></Column> 
              <Column field= "Max_Profit"  header= "Max Profit" ></Column> 
              <Column field= "O_to_C_Point"  header= "Market Point" ></Column> 
              <Column field= "Market_Beat"  header= "Market Beat (in Return %)"></Column> 
              <Column field= "Profit_Loss_Ratio"  header= "Profit/Loss Ratio" ></Column> 
              <Column field= "Avg_profit_trade"  header= "Avg Profit/Trade" ></Column> 
              <Column field= "Avg_loss_trade"  header= "Avg Loss/Trade" ></Column>
              <Column field= 'Holding_Peroid'  header = 'Avg Holding Peroid'></Column>
            </DataTable>
          </div>

          <div className="charts">
            <div className='returnchartCard'>
            <div className='dropdown'>
              <Dropdown value={drpValue} onChange={(e) => {setDrpValue(e.target.value) }} options={symbolsOptions} optionLabel="name" placeholder="Select a Symbol" checkmark={true} highlightOnSelect={false} />
              &emsp;
            </div>
            <div className='returnChart'>  < HighchartsReact highcharts={Highcharts} oneToOne={true} options={optionsReturn} /></div>
            </div>
            
            <div className='multicharts_grid'>
            <div className="grid-container">
              <div>
                <div className='customproperty'>
                <div><h6 className='propertyHeaders'>{drpValue=== 'N50_all' ? 'Nifty 50': drpValue=== 'N50_next_all'? 'Nifty 50 Next' : drpValue}&nbsp;({findKeyByValue(columnRisk,selectedRisk)})</h6></div>
                <div className='chartsheader'>
                    <div><h5 className='propertyHeaders'>Risk</h5></div>
                    <div><Dropdown value={selectedRisk} onChange={(e) => getSelectedRisk(e.target.value)} options={columnRisk} optionLabel="name" placeholder="Select a Property" checkmark={true} highlightOnSelect={false}/></div>
                  </div>
                </div>
                <HighchartsReact highcharts={Highcharts} oneToOne={true} options={optionRisk}/>
              </div>
              <div>
                <div className='customproperty'>
                  <div><h6 className='propertyHeaders'>{drpValue=== 'N50_all' ? 'Nifty 50': drpValue=== 'N50_next_all'? 'Nifty 50 Next' : drpValue}&nbsp;({findKeyByValue(columnReward,selectedReward)})</h6></div>
                  <div className='chartsheader'>
                    <div><h5 className='propertyHeaders'>Rewards</h5></div>                    
                    <div><Dropdown value={selectedReward} onChange={(e) => getSelectedReward(e.target.value)} options={columnReward} optionLabel="name" placeholder="Select a Property" checkmark={true} highlightOnSelect={false} /></div>
                </div>
                </div>
                <HighchartsReact highcharts={Highcharts} oneToOne={true} options={optionReward} />              
              </div>
              <div>
                <div className='customproperty'>
                <div><h6 className='propertyHeaders'>{drpValue=== 'N50_all' ? 'Nifty 50': drpValue=== 'N50_next_all'? 'Nifty 50 Next' : drpValue}&nbsp;({findKeyByValue(columnMisc,selectedMisc)})</h6></div>
                <div className='chartsheader'>
                  <div><h5 className='propertyHeaders'>Miscellaneous</h5></div>
                  <div><Dropdown value={selectedMisc} onChange={(e) => getSelectedMisc(e.target.value)} options={columnMisc} optionLabel="name" placeholder="Select a Property" checkmark={true} highlightOnSelect={false} /></div>
                </div>
                </div>
                <HighchartsReact highcharts={Highcharts} oneToOne={true}  options={optionMisc} />
              </div>
              </div>
            </div>         
          </div>
          <div className='datatable2'>
          <div className='table2_header'>
          <div className='table2_title'><h5 className='adviceStatus_params_heading'>Positive Periods (%) and Market Beat (%)</h5></div>
          <div className='table2_exportButton'><Button type="button" icon="pi pi-download"
           rounded 
           onClick={()=>{
            setSelectedPreviewTableData(rolling);
            setSelectedPreviewTableColumns(equityPositivePeriodAndMarketBeatMappingTableHeader);
            setSelectedPreviewTableColumnMapping(equityPositivePeriodAndMarketBeatMapping);
            setSelectedFileName("Rolling Summary(Monthly_Quarterly_Yearly).csv")
            setIsModalOpen(true);
        
        }}
           className='button1' /></div>
          </div>
          <div className='rolling_monthly'>
            <DataTable value={rolling} scrollable resizableColumns stripedRows sortMode="multiple" >
            <Column field="s_symbol" header="Symbol" sortable ></Column>
            <Column field="rolling_21" header="Monthly(21)" sortable ></Column>
            <Column field="rolling_65" header="Quarterly(63)"  sortable ></Column>
            <Column field="rolling_252" header="Yearly(252)" sortable ></Column>
            <Column field="marketBeat" header="Market Beat" sortable></Column>
            <Column field="score" header="Remarks" body={valueBodyTemplate}></Column>
            </DataTable>
          </div>
          </div>
        </>}
        </div>
      </div>
    </div>
    </div>
  );
}
export default App;


